import { ArticleScreen } from '@/screens/read-screen/ArticleScreen'

export default function () {
  return <ArticleScreen />
}
